module.exports = __webpack_public_path__ + "static/media/palette.e3ec450d.svg";